import { FileText } from "lucide-react";
import { categoryIcons } from "../../lib/constants";

// A single browse-marketplace listing card
export const ListingCard = ({ listing, isBusiness, currentUserId, onBid, onPurchase }) => {
  const Icon = categoryIcons[listing.category] || FileText;
  return (
    <div className="bg-white/5 rounded-2xl p-6 border border-purple-500/20">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500/20 to-cyan-500/20 flex items-center justify-center">
            <Icon className="w-5 h-5 text-purple-400" />
          </div>
          <div>
            <h3 className="font-semibold text-white">{listing.title}</h3>
            <p className="text-sm text-gray-400 capitalize">{listing.category}</p>
          </div>
        </div>
      </div>
      <p className="text-gray-400 text-sm mb-4 line-clamp-2">{listing.description}</p>
      {listing.highest_bid != null && (
        <p className="text-xs text-cyan-400 mb-3" data-testid="listing-highest-bid">Highest bid: ${listing.highest_bid.toFixed(2)}</p>
      )}
      <div className="flex items-center justify-between pt-4 border-t border-purple-500/20">
        <div>
          <p className="text-xl font-bold text-white">${listing.price.toFixed(2)}</p>
          <p className="text-xs text-gray-500">by {listing.seller_name}</p>
        </div>
        {listing.seller_id !== currentUserId && (
          <div className="flex gap-2">
            {isBusiness && (
              <button
                onClick={() => onBid(listing)}
                className="px-4 py-2 bg-white/10 text-white rounded-lg text-sm font-medium hover:bg-white/20 transition border border-purple-500/30"
                data-testid={`place-bid-btn-${listing.id}`}
              >
                Place Bid
              </button>
            )}
            <button
              onClick={() => onPurchase(listing.id)}
              className="px-4 py-2 bg-gradient-to-r from-purple-600 to-cyan-500 text-white rounded-lg text-sm font-medium hover:shadow-lg transition"
              data-testid={`buy-now-btn-${listing.id}`}
            >
              Buy Now
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
